import Search from '@anm/components/Search';
import { useCallback, useContext, useEffect, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RouterContext } from '../../../contexts/RouterContext';
import { projectActions, projectSelectors } from '../../../store/modules/project';

export type MyProjectsSearchProps = { isAlwaysOpen?: boolean };

const MyProjectsSearch: FC<MyProjectsSearchProps> = ({ isAlwaysOpen }) => {
  const dispatch = useDispatch();
  const searchWord = useSelector(projectSelectors.selectProjectsSearchKeyWord);
  const { history } = useContext(RouterContext);

  const handleSearch = useCallback((keyword: string) => {
    dispatch(projectActions.searchProjects(keyword));
  }, []);
  const handleOpen = useCallback(() => {
    dispatch(projectActions.changeSearchOpen(true));
  }, []);

  const handleClose = useCallback(() => {
    dispatch(projectActions.cancelSearchProjects());
  }, []);

  useEffect(() => {
    if (!searchWord) return;

    const route = history?.[1];
    const isBack = route?.to.includes('/videos') && route?.type === 'back';

    if (!isBack) {
      handleClose();
    }
  }, []);

  return (
    <Search
      text={searchWord || ''}
      isAlwaysOpen={isAlwaysOpen}
      placeholder="Search in my videos"
      onSearch={handleSearch}
      onOpen={handleOpen}
      onClose={handleClose}
    />
  );
};

export default MyProjectsSearch;
